import { render } from "./CustomHeightProgressBars.vue?vue&type=template&id=d5612fd4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__